import { Box } from "@chakra-ui/react";
import { useOptimizely } from "hooks/useOptimizely";
import { howItWorksConfig, howItWorksExperimentVariationIds } from "./config";
import { HowItWorksContainer } from "./HowItWorksContainer";

export const HowItWorks = () => {
  const { variationId } = useOptimizely({
    experimentName: "Multivariate test on Homepage",
    experimentId: 26528150322,
  });

  if (howItWorksExperimentVariationIds.includes(variationId)) {
    return (
      <Box bg="greyscale.300" display={{ base: "block", md: "none" }}>
        <HowItWorksContainer {...howItWorksConfig} />
      </Box>
    );
  }

  return null;
};
